export default {
	sec_10: {
		title: {
			one: '送金手数料',
			two: '無料',
		},
		desc: {
			one: 'JP WORLD PAY間の送金時手数料無料!',
		},
		btn: {
			one: '会員登録',
			two: 'アプリダウンロード',
		},
	},
	sec_11: {
		one: {
			title: {
				one: '外部ウォレット入金時',
				two: 'ネットワーク費用のみ',
			},
			desc: {
				one: '入金時JP WORLD PAYでは 手数料支払い要請を致しません。',
			},
		},
		two: {
			title: {
				one: '自社のプラットフォーム内の移動は無料です。',
			},
			desc: {
				one: '外部出金時のみ手数料発生JP WORLD PAYを利用性手購入時手数料無料',
			},
		},
	},
};
